import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const RepresentativesListModuleStyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const RepresentativesItemStyledContainer = styled(Box)`
  .card {
	display: flex;
	flex-direction: column;
  }

  .fields {
    display: grid;
    position: relative;
    gap: 20px;
    grid-template-columns: 1.3fr repeat(3, 1fr) 60px;
  }

  .module-control-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .access-right,
  .working-with-applications {
    legend {
      font-size: 0.85em !important;
    }
  }

  .root-error {
	margin-left: auto;
	margin-right: 10px;
  }
`;

export { RepresentativesListModuleStyledContainer, RepresentativesItemStyledContainer };
